var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "device-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-mobile-phone" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("device.titles.list")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiDrawer",
        {
          attrs: { title: _vm.$t("users.drawer_title") },
          model: {
            value: _vm.isOpen,
            callback: function ($$v) {
              _vm.isOpen = $$v
            },
            expression: "isOpen",
          },
        },
        [
          _vm.useDvFlagAccess("beepiz-licence-can:update")
            ? _c("div", { staticStyle: { "margin-top": "30px" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("users.selectNumber1")) + "\n        "),
                  _c("span", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(_vm.selectedElements.length)),
                  ]),
                  _vm._v("\n        " + _vm._s(_vm.$t("users.users"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "40px" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("users.attribute"))),
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("device.registrations.profile"))),
                ]),
                _vm._v("\n        " + _vm._s(_vm.$t("users.atUserSelected"))),
              ]),
              _vm._v(" "),
              _c("b-form-select", {
                staticStyle: { "margin-top": "10px" },
                attrs: { options: _vm.profilesList },
                model: {
                  value: _vm.licenceProfileSelection,
                  callback: function ($$v) {
                    _vm.licenceProfileSelection = $$v
                  },
                  expression: "licenceProfileSelection",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-group-can:update")
            ? _c(
                "div",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("users.attribute"))),
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v(_vm._s(_vm.$t("device.group.group"))),
                    ]),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("users.atUserSelected"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { options: _vm.groupsList },
                    model: {
                      value: _vm.licenceGroupSelection,
                      callback: function ($$v) {
                        _vm.licenceGroupSelection = $$v
                      },
                      expression: "licenceGroupSelection",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: !(
                      _vm.licenceGroupSelection || _vm.licenceProfileSelection
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.sendUserDatas()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("users.validate")) + "\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _vm.useDvFlagAccess("beepiz-licence-can:update") ||
          _vm.useDvFlagAccess("beepiz-group-can:update")
            ? _c(
                "b-button",
                {
                  staticClass: "mr-2 mb-3",
                  attrs: {
                    size: "sm",
                    disabled: _vm.selectedElements.length === 0,
                  },
                  on: { click: _vm.openModification },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("users.modify")) +
                      " (" +
                      _vm._s(_vm.selectedElements.length) +
                      ")\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col col-xl-12" },
              [
                _c("div", { staticClass: "mb-3" }, [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$tc("device.count", _vm.count, { count: _vm.count })
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("SuperTable", {
                  ref: "tableIdentifications",
                  attrs: {
                    tableColumns: _vm.tableColumns,
                    tableData: _vm.tableData,
                    loading: _vm.loading,
                  },
                  on: {
                    sort: _vm.handleSort,
                    filter: _vm.handleFilter,
                    onSelectAll: _vm.handleSelectAll,
                    onSelectRow: _vm.handleSelectItem,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "float-right" },
              [
                _c(
                  "Btn",
                  {
                    class: [{ disabled: _vm.downloadExport }, "default"],
                    staticStyle: { "margin-left": "auto" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.exportDevices()
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v("   " + _vm._s(_vm.$t("global.download"))),
                    ]),
                    _vm._v(" "),
                    _c("LoadingMini", { ref: "loading" }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }